import { render, staticRenderFns } from "./MainPageKeyAdvantage.vue?vue&type=template&id=1f6a18fb&scoped=true&"
import script from "./MainPageKeyAdvantage.vue?vue&type=script&lang=js&"
export * from "./MainPageKeyAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./MainPageKeyAdvantage.vue?vue&type=style&index=0&id=1f6a18fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a18fb",
  null
  
)

export default component.exports